import React from 'react';

import {
  Canvas,
} from './6_canvas';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import {
  getFooObj,
  getTreeLoaded,
  getUnions,
  getBranches,
  getNodeObjs,
  getFanChartData,
  getFanChartUniqueChars,
  getHashWidthsNamesForFanchart,
  get_nodeobjsbyrange,
  get_countOf,
  getlookUpPrId,
  getProfileObjs,
  getViewport,
  getProgress,
  getFlipcardData,
  getPreferences,
  getEdges,
  get_focusnode,
  get_cid_grps,
  get_firstTreeMatchCountNode,
  get_firstRecordMatchCountNode,
  get_firstMaleGhostNode,
  get_firstFemaleGhostNode,
  get_firstTreeMatchNode,
  get_firstDeadNode,
  get_firstRecordMatchNode,
  get_firstSmartMatchNode,
  get_multipleParentNode,
  get_firstConflictNode,
  get_firstDNANode,
  get_firstCycleMasterNode,
  get_firstEditNode,
  get_firstEmailRequestNode,
  get_firstInconsistentencyNode,
  get_firstMergePendingNode,
  get_firstAppear05Node,
  get_firstAppear06Node,
  get_firstAppear07Node,
  get_firstAppear08Node,
  get_firstAppear09Node,
  get_numofgenerations,
  getDualPedigreeObj,
  getFanchartObj,
  getResolve,
  getIsPedigree,
  getIsFanChart,
  getChartType,
  getMaxAncestorGen,
  getIsDualPedigree,
  getCanvasWidth,
  getCanvasHeight,
  getCanvasTop,
  getShiftDownCanvasTop,
  getFocusPrId,
  getFloaters,
  getIsLargeTree,
  getLegendDescriptions,
  getNodeCount,
  getDualPedigreePosterId,
} from '../../controller/selectors';
import {
  fetch_something,
  fetchTree,
  setPreferences,
  fetchImmediateFamily,
  fetchLegendDescriptions,
  fetchProfiles,
  releaseQueueFetchedProfilesData,
  releaseQueueOfFetchedNodeobjPics,
  notifyProfileAdd,
  updateMatchCounts,
  checkqueuefetchednodeobjpic,
  fetchFloaters,
  fetchPrunes,
  flushallcallbackforfetchprofiles,
  fetchFlipData,
  unsetFlipData,
  unsetNodeObjProp,
  unsetNodeObjPic,
  setNodeObjPic,
  // storeCustomRecenterInDualpedigree,
  setProgressLoaded,
  unsetNodeObjGedcom,
  postInvite,
  postResolve,
  postPreferences,
  postPoster,
  getUnionIdForFanChart,
  uploadphoto,
  postreduxpreferences,
  postPreferencesChartType,
  postChosenUnionId,
  postAddExisting,
  addFloater,
  removeFloater,
  fetchPreferences,
  setPrId,
  setViewport,
  setReduxCanvasHeightTop,
  setCanvasWidth,
  setCanvasHeight,
  stop_inflight_sagas,
  designateDropTarget,
  undesignateDropTarget,
  cancelAllSpawnedFetchProfiles,
} from '../../controller/actions';
import {
  getInitialPrId,
  urlGet,
} from '../../library/calc';
import {
  version,
  gitMessage,
  dateCommit,
  dualPedigreeMode,
  dualPedigreeLaunchOnDev,
  fontArray,
  forceFanChart,
  isDevelopment,
} from '../../library/constants';

export class Tree extends React.PureComponent {

  constructor(props){
    super(props);

    this.initialPrId = getInitialPrId();

    const styles = [
      'color: white',
      'background: black',
      'font-size: 14px',
      'border: 5px solid orange',
      'padding: 10px',
    ].join(';');

    console.log(`%cVer: ${version} - ${dateCommit}`, styles);
    console.log(`git: ${gitMessage}`);

    setTimeout(() => {

        console.log(`%cVer: ${version} - ${dateCommit}`, styles);
        console.log(`git: ${gitMessage}`);

    }, 7000);

    if (!this.props.treeLoaded) {
      const fromWhere = 'constructor';
      this.props.setPrId(this.initialPrId, fromWhere);

      /*
      const callback = (nodeObjs) =>{
        let newPrunesObj = {};
        for (let n in nodeObjs) {
          var nodeObj = nodeObjs[n];
          if( nodeObj.p === '+' ) {
            newPrunesObj[nodeObj.pid] = n;
          };
        }
        if(this.props.isPedigree){
          this.props.fetchPrunes({newPrunesObj});
        }
      }*/

      const families = fontArray.map((font)=>{return font.name})
      window.WebFont.load({
        google: {
          families
        }
      });

      if( dualPedigreeLaunchOnDev ){

         const callFetchTree = () => {
          this.props.fetchTree({fromWhere: 'tree constructor dualPedigreeLaunchOnDev'});
        }
        this.props.postPoster({action:'dev',  callFetchTree})
        return;
      }

      if( dualPedigreeMode && !isDevelopment ){

        if( urlGet('deletePosters') === 'true') {
          const tpId = urlGet('tpId')
          this.props.postPoster({ action:'delete', tpId})
          return;
        }

        const callFetchTree = ({unionId}) => {
             console.log(`%c unionId: ${unionId}`, [
               'color: white',
               'background: orange',
               'font-size: 14px',
               'border: 5px solid red',
               'padding: 10px',
               ].join(';'));

          const callback = () => {
            setTimeout(() => {
              if(window.Geni) window.Geni.hidePageSpinner();
            }, 4000);

          }

          this.props.fetchTree({unionId, callback, fromWhere: 'tree constructor dualPedigreeMode'});
        }

        this.props.postPoster({action:'start', focusPrId: this.initialPrId, callFetchTree})

      } else if( forceFanChart && !isDevelopment ){

        const callFetchTree = ({unionId}) => {

          this.props.fetchTree({unionId, fromWhere: 'fanchart'});

        }

        this.props.getUnionIdForFanChart({focusPrId: this.initialPrId, callFetchTree})

      } else {

        // if(!isDevelopment) window.Geni.showPageSpinner();
        const callback = () => {

          if(window.Geni) window.Geni.hidePageSpinner();

        }

        this.props.fetchTree({fromWhere: 'tree constructor', callback});

      }
    }}

    render() {

      const { viewport, ...rest } = this.props;

      const canvasProps = {
        viewPortSides: {
          top: viewport.get('top'),
          right: viewport.get('right'),
          bottom: viewport.get('bottom'),
          left: viewport.get('left'),
        },
        ...rest,
      };

      return <Canvas {...canvasProps} />;

    }
}

export function mapDispatchToProps(dispatch) {
  return {
    fetch_something: (obj) => dispatch(fetch_something(obj)),
    setPrId: prId => dispatch(setPrId(prId)),
    fetchTree: (obj) => dispatch(fetchTree(obj)),
    setPreferences: (obj) => dispatch(setPreferences(obj)),
    fetchImmediateFamily: (obj) => dispatch(fetchImmediateFamily(obj)),
    fetchLegendDescriptions: (obj) => dispatch(fetchLegendDescriptions(obj)),
    fetchPrunes: (obj) => dispatch(fetchPrunes(obj)),
    flushallcallbackforfetchprofiles: (obj) => dispatch(flushallcallbackforfetchprofiles()),
    fetchProfiles: (obj) => dispatch(fetchProfiles(obj)),
    releaseQueueFetchedProfilesData: (obj) => dispatch(releaseQueueFetchedProfilesData(obj)),
    releaseQueueOfFetchedNodeobjPics: (obj) => dispatch(releaseQueueOfFetchedNodeobjPics(obj)),
    notifyProfileAdd: (obj) => dispatch(notifyProfileAdd(obj)),
    updateMatchCounts: (obj) => dispatch(updateMatchCounts(obj)),
    checkqueuefetchednodeobjpic: (obj) => dispatch(checkqueuefetchednodeobjpic(obj)),
    fetchFloaters: (obj) => dispatch(fetchFloaters(obj)),
    postInvite: (obj) => dispatch(postInvite(obj)),
    postResolve: (obj) => dispatch(postResolve(obj)),
    postPreferences: (obj) => dispatch(postPreferences(obj)),
    postPoster: (obj) => dispatch(postPoster(obj)),
    getUnionIdForFanChart: (obj) => dispatch(getUnionIdForFanChart(obj)),
    uploadphoto: (obj) => dispatch(uploadphoto(obj)),
    postreduxpreferences: (obj) => dispatch(postreduxpreferences(obj)),
    postPreferencesChartType: (obj) => dispatch(postPreferencesChartType(obj)),
    postChosenUnionId: (obj) => dispatch(postChosenUnionId(obj)),
    postAddExisting: (obj) => dispatch(postAddExisting(obj)),
    addFloater: (obj) => dispatch(addFloater(obj)),
    removeFloater: (obj) => dispatch(removeFloater(obj)),
    fetchPreferences: (obj) => dispatch(fetchPreferences(obj)),
    fetchFlipData: (obj) => dispatch(fetchFlipData(obj)),
    unsetFlipData: (obj) => dispatch(unsetFlipData(obj)),
    designateDropTarget: (obj) => dispatch(designateDropTarget(obj)),
    undesignateDropTarget: (obj) => dispatch(undesignateDropTarget(obj)),
    cancelAllSpawnedFetchProfiles: (obj) => dispatch(cancelAllSpawnedFetchProfiles(obj)),
    unsetNodeObjProp: (obj) => dispatch(unsetNodeObjProp(obj)),
    unsetNodeObjPic: (obj) => dispatch(unsetNodeObjPic(obj)),
    setNodeObjPic: (obj) => dispatch(setNodeObjPic(obj)),
    // storeCustomRecenterInDualpedigree: (obj) => dispatch(storeCustomRecenterInDualpedigree(obj)),
    setProgressLoaded: (obj) => dispatch(setProgressLoaded(obj)),
    unsetNodeObjGedcom: (obj) => dispatch(unsetNodeObjGedcom(obj)),
    setViewport: (viewport) => dispatch(setViewport(viewport)),
    setReduxCanvasHeightTop: (sizeObj) => dispatch(setReduxCanvasHeightTop(sizeObj)),
    setCanvasWidth: (sizeObj) => dispatch(setCanvasWidth(sizeObj)),
    setCanvasHeight: (sizeObj) => dispatch(setCanvasHeight(sizeObj)),
    stop_inflight_sagas: () => dispatch(stop_inflight_sagas()),
  };
}

const mapStateToProps = createStructuredSelector({
  treeLoaded: getTreeLoaded(),
  unions: getUnions(),
  branches: getBranches(),
  nodeObjs: getNodeObjs(),
  fanChartData: getFanChartData(),
  uniqueFanChartChars: getFanChartUniqueChars(),
  hashWidthsNamesForFanchart: getHashWidthsNamesForFanchart(),
  nodeObjsByRange: get_nodeobjsbyrange(),
  countOf: get_countOf(),
  lookUpPrId: getlookUpPrId(),
  profileObjs: getProfileObjs(),
  flipData: getFlipcardData(),
  preferences: getPreferences(),
  edges: getEdges(),
  focusNode: get_focusnode(),
  cidsGrps: get_cid_grps(),
  firstTreeMatchCountNode: get_firstTreeMatchCountNode(),
  firstRecordMatchCountNode: get_firstRecordMatchCountNode(),
  firstMaleGhostNode: get_firstMaleGhostNode(),
  firstFemaleGhostNode: get_firstFemaleGhostNode(),
  firstTreeMatchNode: get_firstTreeMatchNode(),
  firstDeadNode: get_firstDeadNode(),
  firstRecordMatchNode: get_firstRecordMatchNode(),
  firstSmartMatchNode: get_firstSmartMatchNode(),
  firstMultipleParentNode: get_multipleParentNode(),
  firstConflictNode: get_firstConflictNode(),
  firstDNANode: get_firstDNANode(),
  firstCycleMaster: get_firstCycleMasterNode(),
  firstEditNode: get_firstEditNode(),
  firstEmailRequestNode: get_firstEmailRequestNode(),
  firstInconsistentencyNode: get_firstInconsistentencyNode(),
  firstMergePendingNode: get_firstMergePendingNode(),
  firstAppear05Node: get_firstAppear05Node(),
  firstAppear06Node: get_firstAppear06Node(),
  firstAppear07Node: get_firstAppear07Node(),
  firstAppear08Node: get_firstAppear08Node(),
  firstAppear09Node: get_firstAppear09Node(),
  numOfGenerations: get_numofgenerations(),
  dualPedigreeObj: getDualPedigreeObj(),
  fanchartObj: getFanchartObj(),
  resolve: getResolve(),
  isPedigree: getIsPedigree(),
  isFanChart: getIsFanChart(),
  chartType: getChartType(),
  maxAncestorGen: getMaxAncestorGen(),
  isDualPedigree: getIsDualPedigree(),
  viewport: getViewport(),
  progress: getProgress(),
  canvasWidth: getCanvasWidth(),
  canvasHeight: getCanvasHeight(),
  canvasTop: getCanvasTop(),
  shiftDownCanvasTop: getShiftDownCanvasTop(),
  focusPrId: getFocusPrId(),
  floaters: getFloaters(),
  isLargeTree: getIsLargeTree(),
  legendDescriptions: getLegendDescriptions(),
  nodeCount: getNodeCount(),
  dualPedigreePosterId: getDualPedigreePosterId(),
});


export default connect(mapStateToProps, mapDispatchToProps)(Tree);
